import React from 'react';
import ChatHeader from './Components/ChatHeader';
import MessageList from './Components/MessageList';
import MessageInput from './Components/MessageInput';
import QuickActions from './Components/QuickActions';
import { useResizable } from './useResizable';
import { useAutoContext } from '../useAutoContext';
import styles from './ChatWidget.module.scss';

interface ChatWidgetLayoutProps {
  onMinimize: () => void;
  onClose: () => void;
}

export default function ChatWidgetLayoutWeb(props: ChatWidgetLayoutProps) {
  useAutoContext();

  const { height, handleRef, panelRef } = useResizable({
    minHeight: 300,
    maxHeightVh: 95,
    initialHeightRem: 50,
  });

  return (
    <div
      className={styles.panel}
      ref={panelRef}
      style={{ height }}
      data-testid="chat-widget"
    >
      <div className={styles.resizeHandle} ref={handleRef} />
      <ChatHeader onMinimize={props.onMinimize} onClose={props.onClose} />
      <MessageList />
      <MessageInput />
      <QuickActions />
    </div>
  );
}
